<div class="skeleton-loader" *ngFor="let item of loaders">
    <div class="avatar-placeholder"></div>
    <div class="text-placeholder">
      <div class="line short"></div>
      <div class="line long"></div>
    </div>
  </div>
  